import RelationshipMetadata from "../../RelationshipMetadata";

class WorkGroupWorkGroupPositionRelationshipMetadata extends RelationshipMetadata {
    constructor() {
        super();

        this.name = "WorkGroupWorkGroupPositionRelationshipMetadata";
        this.parentEnterpriseComponent = "WorkGroup";
        this.childEnterpriseComponent = "WorkGroupPosition";
        this.sourceAttribute = "USID";
        this.destinationAttribute = "WorkGroupUSID";
    }
}

export default WorkGroupWorkGroupPositionRelationshipMetadata;